module.exports = __webpack_public_path__ + "img/Delete.b8315814.svg";